import { CmsPageService } from './../../../shared/services/cms-page.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ICmsPage } from '../../../_models/cms/ICmsPage';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-single-page',
  templateUrl: './single-page.component.html',
  styleUrls: ['./single-page.component.css']
})
export class SinglePageComponent implements OnInit {

  cmsPage: ICmsPage;
  slug: string;
  subscription: Subscription;
  newContent: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private cmsPageService: CmsPageService,
    private sanitizer: DomSanitizer) {
    this.subscription = this.route.params.subscribe(
      (params: Params) => {
        this.slug = params.slug;
        this.loadCmsPage();
      });
  }

  ngOnInit() {
  }

  loadCmsPage() {
    if (this.slug) this.cmsPageService.getBySlug(this.slug).subscribe((response: ICmsPage) => {
      if (response) {
        this.cmsPage = response;
        this.cmsPage.content = this.cmsPage.content + '<style>' + this.cmsPage.css  + '</style>';
        this.newContent = this.sanitizer.bypassSecurityTrustHtml(this.cmsPage.content);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

}
